export default {
  chip: {
    marginTop: '8px',
    marginLeft: '8px',
    cursor: 'pointer',
  },
  chipSelected: {
    marginTop: '8px',
    marginLeft: '8px',
    cursor: 'auto',
  },
}



// WEBPACK FOOTER //
// ./src/components/sitewide/Chips/chip-styles.js